import React from 'react';

import DeleteAccount from './Delete';
import DeleteLeftSidePage from './DeleteLeftSidePage';

import './Registration.css';

class DeleteMyAccount extends React.Component {
  render() {
    return (
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8 regsidecol">
              <DeleteLeftSidePage />
            </div>
            <div className="col-md-4 regcol">
              <div className="formdivre">
                <h2 className="pt-1 text-center">Delete My Account</h2>
                <form className="registration-form">
                  <DeleteAccount />
                </form>
              </div>
            </div>                
          </div>
        </div>
      </section> 
    );
  }
}
export default DeleteMyAccount;
